module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: {
      'notice-container-': !_vm.noShowTitle,
      'pt-0': _vm.noShowTitle,
      'pinned-only': _vm.pinnedOnly && _vm.pinned.length > 0,
      'in-stats': _vm.inStats,
      'no-spacing': _vm.pinnedOnly && _vm.pinned.length == 0
    }
  }, [(!_vm.noShowTitle && !_vm.pinnedOnly) ? _c('div', {
    staticClass: "fs-16 text-white-on-dark pb-5"
  }, [_c('b', [_vm._v("Latest News")])]) : _vm._e(), (_vm.pinned.length > 0) ? [_c('div', {
    staticClass: "pinned-container"
  }, _vm._l((_vm.pinned), function(o) {
    return _c('div', {
      staticClass: "notice-"
    }, [_c('div', {
      staticClass: "indicator-w-pin",
      class: 'is-' + o.type
    }, [_c('i', {
      staticClass: "fa fa-thumb-tack"
    })]), _c('div', {
      staticClass: "notice-content-",
      class: {
        'new': o.at > _vm.lastNewsDate
      }
    }, [_c('div', {
      staticClass: "title-",
      domProps: {
        "innerHTML": _vm._s(o.title)
      }
    }), _c('div', {
      staticClass: "time-container-"
    }, [_c('div', {
      staticClass: "time-"
    }, [_vm._v(_vm._s(_vm._f("formatFullDate")(o.at)))]), (o.tweet_url) ? _c('div', {
      staticClass: "tweet"
    }, [_c('div', {
      staticClass: "separator-circle"
    }), _c('a', {
      staticClass: "x-icon hint--right",
      attrs: {
        "aria-label": "View on X",
        "href": o.tweet_url,
        "target": "_blank"
      }
    }, [_c('img', {
      attrs: {
        "src": "/img/icons/xlogo.png"
      }
    })])]) : _vm._e()])])])
  }), 0)] : _vm._e(), _c('div', {
    staticClass: "news-super-container",
    class: {
      'display-none': _vm.pinnedOnly
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showTopShadow),
      expression: "showTopShadow"
    }],
    staticClass: "box-shadow-container top box-shadow-container-top"
  }), _c('div', {
    staticClass: "notice-container ml-15",
    class: {
      'infinite-container': _vm.infiniteScroll
    },
    style: ('max-height: ' + _vm.maxHeightStyle),
    attrs: {
      "id": _vm.id
    }
  }, [_vm._l((_vm.list), function(o) {
    return _c('div', {
      staticClass: "notice-"
    }, [_c('div', {
      staticClass: "indicator",
      class: 'is-' + o.type
    }), _c('div', {
      staticClass: "notice-content-",
      class: {
        'new': o.at > _vm.lastNewsDate
      },
      on: {
        "click": _vm.clearNews
      }
    }, [_c('div', {
      staticClass: "title-",
      domProps: {
        "innerHTML": _vm._s(o.title)
      }
    }), _c('div', {
      staticClass: "time-container-"
    }, [_c('div', {
      staticClass: "time-"
    }, [_vm._v(_vm._s(_vm._f("formatFullDate")(o.at)))]), (o.tweet_url) ? _c('div', {
      staticClass: "tweet"
    }, [_c('div', {
      staticClass: "separator-circle"
    }), _c('a', {
      staticClass: "x-icon hint--right",
      attrs: {
        "aria-label": "View on X",
        "href": o.tweet_url,
        "target": "_blank"
      }
    }, [_c('img', {
      attrs: {
        "src": "/img/icons/xlogo.png"
      }
    })])]) : _vm._e()])])])
  }), (_vm.isLoading) ? _c('div', {
    staticClass: "fs-13 text-white-on-dark has-text-centered"
  }, [_vm._v("Loading...")]) : _vm._e(), (!_vm.isLoading && !_vm.infiniteScroll) ? _c('div', {
    staticClass: "more-news ml-15 has-text-centered"
  }, [_c('div', {
    staticClass: "info-link",
    attrs: {
      "href": "#"
    },
    on: {
      "click": _vm.loadMoreNews
    }
  }, [_c('span', [_vm._v("More news")])])]) : _vm._e()], 2), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showBottomShadow),
      expression: "showBottomShadow"
    }],
    staticClass: "box-shadow-container bottom box-shadow-container-bottom"
  })])], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-f11ab7ae","hasScoped":true}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/c_news.vue
// module id = 395
// module chunks = 1